export const isReceivedTransferOrder = (
  order?: {
    orderId?: string
    isReceivedTransfer?: boolean
    payment?: {
      paymentMethod?: string
      description?: string | null
    }
  } | null
): boolean => {
  const orderId = order?.orderId?.toUpperCase() ?? ''
  const description = order?.payment?.description ?? ''
  const byFlag = order?.isReceivedTransfer === true
  const byOrderId = orderId.startsWith('TRF-')
  const byDescription = /ingresso recebido/i.test(description)
  const result = byFlag || byOrderId || byDescription

  return result
}
